




























import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import Ajax from "@/lib/ajax";
import AppConsts from "@/lib/appconst";

@Component({
  components: {},
})
export default class CreateSiteMap extends AbpBase {
  spinShow: boolean = false;
  url:string=AppConsts.appBaseUrl+'api/SiteMap/UploadFile'

  async saveSiteConfig() {
    (this.$refs.configForm as any).validate(async (valid: boolean) => {
      if (valid) {
      }
    });
  }
  success(e){
    console.log(e,'e');
    this.$Message.success({
      content:'上传sitemap到服务器根目录成功'
    })

  }
   handleBeforeUpload() {
        if (!!window.abp.auth.getToken()) {
            (this.$refs.upload as any).headers["Authorization"] =
                "Bearer " + window.abp.auth.getToken();
        }
        (this.$refs.upload as any).headers[
            ".AspNetCore.Culture"
        ] = window.abp.utils.getCookieValue("Abp.Localization.CultureName");
        (this.$refs.upload as any).headers[
            "Abp.TenantId"
        ] = window.abp.multiTenancy.getTenantIdCookie();
    }
  configRule = {
    adminPhones: [
      {
        required: true,
        message: this.L("FieldIsRequired", undefined, this.L("AdminPhones")),
        trigger: "blur",
      },
    ],
    hotLine: [
      {
        required: true,
        message: this.L("FieldIsRequired", undefined, this.L("Hotline")),
        trigger: "blur",
      },
      // {
      //     pattern: /(^1[3456789]\d{9}$)|(^(0[0-9]{2,3}\-)?([2-9][0-9]{6,7})+(\-[0-9]{1,6})?$)/,
      //     message: this.L("IncorrectFormat",undefined,this.L("Hotline")),
      //     trigger: "blur"
      // }
    ],
    complaintLine: [
      {
        required: true,
        message: this.L("FieldIsRequired", undefined, this.L("ComplaintLine")),
        trigger: "blur",
      },
    ],
    emergencyLine: [
      {
        required: true,
        message: this.L("FieldIsRequired", undefined, this.L("EmergencyLine")),
        trigger: "blur",
      },
    ],
  };
}
